import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_PORTFOLIO_FEATURE_NAME } from './user-portfolio.actions';
import { IUserPortfolioState } from './interfaces/user-portfolio.state.interface';

export const userPortfolioFeatureSelector = createSelector(
  createFeatureSelector<IUserPortfolioState>(USER_PORTFOLIO_FEATURE_NAME),
  state => state,
);

export const invitesSelector = createSelector(
  userPortfolioFeatureSelector,
  state => state.userInvations
    .filter(invite => !invite.accepted_at && !invite.rejected_at),
);
